/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as StorybookImport } from "./routes/storybook";
import { Route as PayImport } from "./routes/pay";
import { Route as LandingImport } from "./routes/landing";
import { Route as AuthImport } from "./routes/auth";
import { Route as AppImport } from "./routes/_app";
import { Route as IndexImport } from "./routes/index";
import { Route as PayIndexImport } from "./routes/pay/index";
import { Route as StorybookVideoImport } from "./routes/storybook/video";
import { Route as StorybookPrimitivesImport } from "./routes/storybook/primitives";
import { Route as StorybookCropperImport } from "./routes/storybook/cropper";
import { Route as StorybookClipSequenceSelectorImport } from "./routes/storybook/clip-sequence-selector";
import { Route as StorybookAudioTrimmerImport } from "./routes/storybook/audio-trimmer";
import { Route as PayCheckoutImport } from "./routes/pay/checkout";
import { Route as InternalLookupImport } from "./routes/internal/lookup";
import { Route as AuthCallbackImport } from "./routes/auth/callback";
import { Route as AppSettingsImport } from "./routes/_app/settings";
import { Route as AppHomeImport } from "./routes/_app/home";
import { Route as AppActorsImport } from "./routes/_app/actors";
import { Route as AppSettingsTeamImport } from "./routes/_app/settings/team";
import { Route as AppSettingsProfileImport } from "./routes/_app/settings/profile";
import { Route as AppSettingsBillingImport } from "./routes/_app/settings/billing";
import { Route as AppProjectsProjectIdIndexImport } from "./routes/_app/projects/$projectId/index";
import { Route as AppProjectsProjectIdVideosVideoIdImport } from "./routes/_app/projects/$projectId/videos/$videoId";
import { Route as AppProjectsProjectIdAudioIdAuditionsImport } from "./routes/_app/projects/$projectId/$audioId/auditions";
import { Route as AppProjectsProjectIdAudioIdAdjustImport } from "./routes/_app/projects/$projectId/$audioId/adjust";

// Create/Update Routes

const StorybookRoute = StorybookImport.update({
  id: "/storybook",
  path: "/storybook",
  getParentRoute: () => rootRoute,
} as any);

const PayRoute = PayImport.update({
  id: "/pay",
  path: "/pay",
  getParentRoute: () => rootRoute,
} as any);

const LandingRoute = LandingImport.update({
  id: "/landing",
  path: "/landing",
  getParentRoute: () => rootRoute,
} as any);

const AuthRoute = AuthImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRoute,
} as any);

const AppRoute = AppImport.update({
  id: "/_app",
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const PayIndexRoute = PayIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PayRoute,
} as any);

const StorybookVideoRoute = StorybookVideoImport.update({
  id: "/video",
  path: "/video",
  getParentRoute: () => StorybookRoute,
} as any);

const StorybookPrimitivesRoute = StorybookPrimitivesImport.update({
  id: "/primitives",
  path: "/primitives",
  getParentRoute: () => StorybookRoute,
} as any);

const StorybookCropperRoute = StorybookCropperImport.update({
  id: "/cropper",
  path: "/cropper",
  getParentRoute: () => StorybookRoute,
} as any);

const StorybookClipSequenceSelectorRoute =
  StorybookClipSequenceSelectorImport.update({
    id: "/clip-sequence-selector",
    path: "/clip-sequence-selector",
    getParentRoute: () => StorybookRoute,
  } as any);

const StorybookAudioTrimmerRoute = StorybookAudioTrimmerImport.update({
  id: "/audio-trimmer",
  path: "/audio-trimmer",
  getParentRoute: () => StorybookRoute,
} as any);

const PayCheckoutRoute = PayCheckoutImport.update({
  id: "/checkout",
  path: "/checkout",
  getParentRoute: () => PayRoute,
} as any);

const InternalLookupRoute = InternalLookupImport.update({
  id: "/internal/lookup",
  path: "/internal/lookup",
  getParentRoute: () => rootRoute,
} as any);

const AuthCallbackRoute = AuthCallbackImport.update({
  id: "/callback",
  path: "/callback",
  getParentRoute: () => AuthRoute,
} as any);

const AppSettingsRoute = AppSettingsImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any);

const AppHomeRoute = AppHomeImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => AppRoute,
} as any);

const AppActorsRoute = AppActorsImport.update({
  id: "/actors",
  path: "/actors",
  getParentRoute: () => AppRoute,
} as any);

const AppSettingsTeamRoute = AppSettingsTeamImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => AppSettingsRoute,
} as any);

const AppSettingsProfileRoute = AppSettingsProfileImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppSettingsRoute,
} as any);

const AppSettingsBillingRoute = AppSettingsBillingImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppSettingsRoute,
} as any);

const AppProjectsProjectIdIndexRoute = AppProjectsProjectIdIndexImport.update({
  id: "/projects/$projectId/",
  path: "/projects/$projectId/",
  getParentRoute: () => AppRoute,
} as any);

const AppProjectsProjectIdVideosVideoIdRoute =
  AppProjectsProjectIdVideosVideoIdImport.update({
    id: "/projects/$projectId/videos/$videoId",
    path: "/projects/$projectId/videos/$videoId",
    getParentRoute: () => AppRoute,
  } as any);

const AppProjectsProjectIdAudioIdAuditionsRoute =
  AppProjectsProjectIdAudioIdAuditionsImport.update({
    id: "/projects/$projectId/$audioId/auditions",
    path: "/projects/$projectId/$audioId/auditions",
    getParentRoute: () => AppRoute,
  } as any);

const AppProjectsProjectIdAudioIdAdjustRoute =
  AppProjectsProjectIdAudioIdAdjustImport.update({
    id: "/projects/$projectId/$audioId/adjust",
    path: "/projects/$projectId/$audioId/adjust",
    getParentRoute: () => AppRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AppImport;
      parentRoute: typeof rootRoute;
    };
    "/auth": {
      id: "/auth";
      path: "/auth";
      fullPath: "/auth";
      preLoaderRoute: typeof AuthImport;
      parentRoute: typeof rootRoute;
    };
    "/landing": {
      id: "/landing";
      path: "/landing";
      fullPath: "/landing";
      preLoaderRoute: typeof LandingImport;
      parentRoute: typeof rootRoute;
    };
    "/pay": {
      id: "/pay";
      path: "/pay";
      fullPath: "/pay";
      preLoaderRoute: typeof PayImport;
      parentRoute: typeof rootRoute;
    };
    "/storybook": {
      id: "/storybook";
      path: "/storybook";
      fullPath: "/storybook";
      preLoaderRoute: typeof StorybookImport;
      parentRoute: typeof rootRoute;
    };
    "/_app/actors": {
      id: "/_app/actors";
      path: "/actors";
      fullPath: "/actors";
      preLoaderRoute: typeof AppActorsImport;
      parentRoute: typeof AppImport;
    };
    "/_app/home": {
      id: "/_app/home";
      path: "/home";
      fullPath: "/home";
      preLoaderRoute: typeof AppHomeImport;
      parentRoute: typeof AppImport;
    };
    "/_app/settings": {
      id: "/_app/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AppSettingsImport;
      parentRoute: typeof AppImport;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthCallbackImport;
      parentRoute: typeof AuthImport;
    };
    "/internal/lookup": {
      id: "/internal/lookup";
      path: "/internal/lookup";
      fullPath: "/internal/lookup";
      preLoaderRoute: typeof InternalLookupImport;
      parentRoute: typeof rootRoute;
    };
    "/pay/checkout": {
      id: "/pay/checkout";
      path: "/checkout";
      fullPath: "/pay/checkout";
      preLoaderRoute: typeof PayCheckoutImport;
      parentRoute: typeof PayImport;
    };
    "/storybook/audio-trimmer": {
      id: "/storybook/audio-trimmer";
      path: "/audio-trimmer";
      fullPath: "/storybook/audio-trimmer";
      preLoaderRoute: typeof StorybookAudioTrimmerImport;
      parentRoute: typeof StorybookImport;
    };
    "/storybook/clip-sequence-selector": {
      id: "/storybook/clip-sequence-selector";
      path: "/clip-sequence-selector";
      fullPath: "/storybook/clip-sequence-selector";
      preLoaderRoute: typeof StorybookClipSequenceSelectorImport;
      parentRoute: typeof StorybookImport;
    };
    "/storybook/cropper": {
      id: "/storybook/cropper";
      path: "/cropper";
      fullPath: "/storybook/cropper";
      preLoaderRoute: typeof StorybookCropperImport;
      parentRoute: typeof StorybookImport;
    };
    "/storybook/primitives": {
      id: "/storybook/primitives";
      path: "/primitives";
      fullPath: "/storybook/primitives";
      preLoaderRoute: typeof StorybookPrimitivesImport;
      parentRoute: typeof StorybookImport;
    };
    "/storybook/video": {
      id: "/storybook/video";
      path: "/video";
      fullPath: "/storybook/video";
      preLoaderRoute: typeof StorybookVideoImport;
      parentRoute: typeof StorybookImport;
    };
    "/pay/": {
      id: "/pay/";
      path: "/";
      fullPath: "/pay/";
      preLoaderRoute: typeof PayIndexImport;
      parentRoute: typeof PayImport;
    };
    "/_app/settings/billing": {
      id: "/_app/settings/billing";
      path: "/billing";
      fullPath: "/settings/billing";
      preLoaderRoute: typeof AppSettingsBillingImport;
      parentRoute: typeof AppSettingsImport;
    };
    "/_app/settings/profile": {
      id: "/_app/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof AppSettingsProfileImport;
      parentRoute: typeof AppSettingsImport;
    };
    "/_app/settings/team": {
      id: "/_app/settings/team";
      path: "/team";
      fullPath: "/settings/team";
      preLoaderRoute: typeof AppSettingsTeamImport;
      parentRoute: typeof AppSettingsImport;
    };
    "/_app/projects/$projectId/": {
      id: "/_app/projects/$projectId/";
      path: "/projects/$projectId";
      fullPath: "/projects/$projectId";
      preLoaderRoute: typeof AppProjectsProjectIdIndexImport;
      parentRoute: typeof AppImport;
    };
    "/_app/projects/$projectId/$audioId/adjust": {
      id: "/_app/projects/$projectId/$audioId/adjust";
      path: "/projects/$projectId/$audioId/adjust";
      fullPath: "/projects/$projectId/$audioId/adjust";
      preLoaderRoute: typeof AppProjectsProjectIdAudioIdAdjustImport;
      parentRoute: typeof AppImport;
    };
    "/_app/projects/$projectId/$audioId/auditions": {
      id: "/_app/projects/$projectId/$audioId/auditions";
      path: "/projects/$projectId/$audioId/auditions";
      fullPath: "/projects/$projectId/$audioId/auditions";
      preLoaderRoute: typeof AppProjectsProjectIdAudioIdAuditionsImport;
      parentRoute: typeof AppImport;
    };
    "/_app/projects/$projectId/videos/$videoId": {
      id: "/_app/projects/$projectId/videos/$videoId";
      path: "/projects/$projectId/videos/$videoId";
      fullPath: "/projects/$projectId/videos/$videoId";
      preLoaderRoute: typeof AppProjectsProjectIdVideosVideoIdImport;
      parentRoute: typeof AppImport;
    };
  }
}

// Create and export the route tree

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute;
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute;
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute;
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
};

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
);

interface AppRouteChildren {
  AppActorsRoute: typeof AppActorsRoute;
  AppHomeRoute: typeof AppHomeRoute;
  AppSettingsRoute: typeof AppSettingsRouteWithChildren;
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute;
  AppProjectsProjectIdAudioIdAdjustRoute: typeof AppProjectsProjectIdAudioIdAdjustRoute;
  AppProjectsProjectIdAudioIdAuditionsRoute: typeof AppProjectsProjectIdAudioIdAuditionsRoute;
  AppProjectsProjectIdVideosVideoIdRoute: typeof AppProjectsProjectIdVideosVideoIdRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppActorsRoute: AppActorsRoute,
  AppHomeRoute: AppHomeRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
  AppProjectsProjectIdAudioIdAdjustRoute:
    AppProjectsProjectIdAudioIdAdjustRoute,
  AppProjectsProjectIdAudioIdAuditionsRoute:
    AppProjectsProjectIdAudioIdAuditionsRoute,
  AppProjectsProjectIdVideosVideoIdRoute:
    AppProjectsProjectIdVideosVideoIdRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

interface AuthRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface PayRouteChildren {
  PayCheckoutRoute: typeof PayCheckoutRoute;
  PayIndexRoute: typeof PayIndexRoute;
}

const PayRouteChildren: PayRouteChildren = {
  PayCheckoutRoute: PayCheckoutRoute,
  PayIndexRoute: PayIndexRoute,
};

const PayRouteWithChildren = PayRoute._addFileChildren(PayRouteChildren);

interface StorybookRouteChildren {
  StorybookAudioTrimmerRoute: typeof StorybookAudioTrimmerRoute;
  StorybookClipSequenceSelectorRoute: typeof StorybookClipSequenceSelectorRoute;
  StorybookCropperRoute: typeof StorybookCropperRoute;
  StorybookPrimitivesRoute: typeof StorybookPrimitivesRoute;
  StorybookVideoRoute: typeof StorybookVideoRoute;
}

const StorybookRouteChildren: StorybookRouteChildren = {
  StorybookAudioTrimmerRoute: StorybookAudioTrimmerRoute,
  StorybookClipSequenceSelectorRoute: StorybookClipSequenceSelectorRoute,
  StorybookCropperRoute: StorybookCropperRoute,
  StorybookPrimitivesRoute: StorybookPrimitivesRoute,
  StorybookVideoRoute: StorybookVideoRoute,
};

const StorybookRouteWithChildren = StorybookRoute._addFileChildren(
  StorybookRouteChildren,
);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "": typeof AppRouteWithChildren;
  "/auth": typeof AuthRouteWithChildren;
  "/landing": typeof LandingRoute;
  "/pay": typeof PayRouteWithChildren;
  "/storybook": typeof StorybookRouteWithChildren;
  "/actors": typeof AppActorsRoute;
  "/home": typeof AppHomeRoute;
  "/settings": typeof AppSettingsRouteWithChildren;
  "/auth/callback": typeof AuthCallbackRoute;
  "/internal/lookup": typeof InternalLookupRoute;
  "/pay/checkout": typeof PayCheckoutRoute;
  "/storybook/audio-trimmer": typeof StorybookAudioTrimmerRoute;
  "/storybook/clip-sequence-selector": typeof StorybookClipSequenceSelectorRoute;
  "/storybook/cropper": typeof StorybookCropperRoute;
  "/storybook/primitives": typeof StorybookPrimitivesRoute;
  "/storybook/video": typeof StorybookVideoRoute;
  "/pay/": typeof PayIndexRoute;
  "/settings/billing": typeof AppSettingsBillingRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/settings/team": typeof AppSettingsTeamRoute;
  "/projects/$projectId": typeof AppProjectsProjectIdIndexRoute;
  "/projects/$projectId/$audioId/adjust": typeof AppProjectsProjectIdAudioIdAdjustRoute;
  "/projects/$projectId/$audioId/auditions": typeof AppProjectsProjectIdAudioIdAuditionsRoute;
  "/projects/$projectId/videos/$videoId": typeof AppProjectsProjectIdVideosVideoIdRoute;
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "": typeof AppRouteWithChildren;
  "/auth": typeof AuthRouteWithChildren;
  "/landing": typeof LandingRoute;
  "/storybook": typeof StorybookRouteWithChildren;
  "/actors": typeof AppActorsRoute;
  "/home": typeof AppHomeRoute;
  "/settings": typeof AppSettingsRouteWithChildren;
  "/auth/callback": typeof AuthCallbackRoute;
  "/internal/lookup": typeof InternalLookupRoute;
  "/pay/checkout": typeof PayCheckoutRoute;
  "/storybook/audio-trimmer": typeof StorybookAudioTrimmerRoute;
  "/storybook/clip-sequence-selector": typeof StorybookClipSequenceSelectorRoute;
  "/storybook/cropper": typeof StorybookCropperRoute;
  "/storybook/primitives": typeof StorybookPrimitivesRoute;
  "/storybook/video": typeof StorybookVideoRoute;
  "/pay": typeof PayIndexRoute;
  "/settings/billing": typeof AppSettingsBillingRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/settings/team": typeof AppSettingsTeamRoute;
  "/projects/$projectId": typeof AppProjectsProjectIdIndexRoute;
  "/projects/$projectId/$audioId/adjust": typeof AppProjectsProjectIdAudioIdAdjustRoute;
  "/projects/$projectId/$audioId/auditions": typeof AppProjectsProjectIdAudioIdAuditionsRoute;
  "/projects/$projectId/videos/$videoId": typeof AppProjectsProjectIdVideosVideoIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/auth": typeof AuthRouteWithChildren;
  "/landing": typeof LandingRoute;
  "/pay": typeof PayRouteWithChildren;
  "/storybook": typeof StorybookRouteWithChildren;
  "/_app/actors": typeof AppActorsRoute;
  "/_app/home": typeof AppHomeRoute;
  "/_app/settings": typeof AppSettingsRouteWithChildren;
  "/auth/callback": typeof AuthCallbackRoute;
  "/internal/lookup": typeof InternalLookupRoute;
  "/pay/checkout": typeof PayCheckoutRoute;
  "/storybook/audio-trimmer": typeof StorybookAudioTrimmerRoute;
  "/storybook/clip-sequence-selector": typeof StorybookClipSequenceSelectorRoute;
  "/storybook/cropper": typeof StorybookCropperRoute;
  "/storybook/primitives": typeof StorybookPrimitivesRoute;
  "/storybook/video": typeof StorybookVideoRoute;
  "/pay/": typeof PayIndexRoute;
  "/_app/settings/billing": typeof AppSettingsBillingRoute;
  "/_app/settings/profile": typeof AppSettingsProfileRoute;
  "/_app/settings/team": typeof AppSettingsTeamRoute;
  "/_app/projects/$projectId/": typeof AppProjectsProjectIdIndexRoute;
  "/_app/projects/$projectId/$audioId/adjust": typeof AppProjectsProjectIdAudioIdAdjustRoute;
  "/_app/projects/$projectId/$audioId/auditions": typeof AppProjectsProjectIdAudioIdAuditionsRoute;
  "/_app/projects/$projectId/videos/$videoId": typeof AppProjectsProjectIdVideosVideoIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | ""
    | "/auth"
    | "/landing"
    | "/pay"
    | "/storybook"
    | "/actors"
    | "/home"
    | "/settings"
    | "/auth/callback"
    | "/internal/lookup"
    | "/pay/checkout"
    | "/storybook/audio-trimmer"
    | "/storybook/clip-sequence-selector"
    | "/storybook/cropper"
    | "/storybook/primitives"
    | "/storybook/video"
    | "/pay/"
    | "/settings/billing"
    | "/settings/profile"
    | "/settings/team"
    | "/projects/$projectId"
    | "/projects/$projectId/$audioId/adjust"
    | "/projects/$projectId/$audioId/auditions"
    | "/projects/$projectId/videos/$videoId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | ""
    | "/auth"
    | "/landing"
    | "/storybook"
    | "/actors"
    | "/home"
    | "/settings"
    | "/auth/callback"
    | "/internal/lookup"
    | "/pay/checkout"
    | "/storybook/audio-trimmer"
    | "/storybook/clip-sequence-selector"
    | "/storybook/cropper"
    | "/storybook/primitives"
    | "/storybook/video"
    | "/pay"
    | "/settings/billing"
    | "/settings/profile"
    | "/settings/team"
    | "/projects/$projectId"
    | "/projects/$projectId/$audioId/adjust"
    | "/projects/$projectId/$audioId/auditions"
    | "/projects/$projectId/videos/$videoId";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/auth"
    | "/landing"
    | "/pay"
    | "/storybook"
    | "/_app/actors"
    | "/_app/home"
    | "/_app/settings"
    | "/auth/callback"
    | "/internal/lookup"
    | "/pay/checkout"
    | "/storybook/audio-trimmer"
    | "/storybook/clip-sequence-selector"
    | "/storybook/cropper"
    | "/storybook/primitives"
    | "/storybook/video"
    | "/pay/"
    | "/_app/settings/billing"
    | "/_app/settings/profile"
    | "/_app/settings/team"
    | "/_app/projects/$projectId/"
    | "/_app/projects/$projectId/$audioId/adjust"
    | "/_app/projects/$projectId/$audioId/auditions"
    | "/_app/projects/$projectId/videos/$videoId";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
  LandingRoute: typeof LandingRoute;
  PayRoute: typeof PayRouteWithChildren;
  StorybookRoute: typeof StorybookRouteWithChildren;
  InternalLookupRoute: typeof InternalLookupRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  LandingRoute: LandingRoute,
  PayRoute: PayRouteWithChildren,
  StorybookRoute: StorybookRouteWithChildren,
  InternalLookupRoute: InternalLookupRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/auth",
        "/landing",
        "/pay",
        "/storybook",
        "/internal/lookup"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/actors",
        "/_app/home",
        "/_app/settings",
        "/_app/projects/$projectId/",
        "/_app/projects/$projectId/$audioId/adjust",
        "/_app/projects/$projectId/$audioId/auditions",
        "/_app/projects/$projectId/videos/$videoId"
      ]
    },
    "/auth": {
      "filePath": "auth.tsx",
      "children": [
        "/auth/callback"
      ]
    },
    "/landing": {
      "filePath": "landing.tsx"
    },
    "/pay": {
      "filePath": "pay.tsx",
      "children": [
        "/pay/checkout",
        "/pay/"
      ]
    },
    "/storybook": {
      "filePath": "storybook.tsx",
      "children": [
        "/storybook/audio-trimmer",
        "/storybook/clip-sequence-selector",
        "/storybook/cropper",
        "/storybook/primitives",
        "/storybook/video"
      ]
    },
    "/_app/actors": {
      "filePath": "_app/actors.tsx",
      "parent": "/_app"
    },
    "/_app/home": {
      "filePath": "_app/home.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app/settings.tsx",
      "parent": "/_app",
      "children": [
        "/_app/settings/billing",
        "/_app/settings/profile",
        "/_app/settings/team"
      ]
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx",
      "parent": "/auth"
    },
    "/internal/lookup": {
      "filePath": "internal/lookup.tsx"
    },
    "/pay/checkout": {
      "filePath": "pay/checkout.tsx",
      "parent": "/pay"
    },
    "/storybook/audio-trimmer": {
      "filePath": "storybook/audio-trimmer.tsx",
      "parent": "/storybook"
    },
    "/storybook/clip-sequence-selector": {
      "filePath": "storybook/clip-sequence-selector.tsx",
      "parent": "/storybook"
    },
    "/storybook/cropper": {
      "filePath": "storybook/cropper.tsx",
      "parent": "/storybook"
    },
    "/storybook/primitives": {
      "filePath": "storybook/primitives.tsx",
      "parent": "/storybook"
    },
    "/storybook/video": {
      "filePath": "storybook/video.tsx",
      "parent": "/storybook"
    },
    "/pay/": {
      "filePath": "pay/index.tsx",
      "parent": "/pay"
    },
    "/_app/settings/billing": {
      "filePath": "_app/settings/billing.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/profile": {
      "filePath": "_app/settings/profile.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/team": {
      "filePath": "_app/settings/team.tsx",
      "parent": "/_app/settings"
    },
    "/_app/projects/$projectId/": {
      "filePath": "_app/projects/$projectId/index.tsx",
      "parent": "/_app"
    },
    "/_app/projects/$projectId/$audioId/adjust": {
      "filePath": "_app/projects/$projectId/$audioId/adjust.tsx",
      "parent": "/_app"
    },
    "/_app/projects/$projectId/$audioId/auditions": {
      "filePath": "_app/projects/$projectId/$audioId/auditions.tsx",
      "parent": "/_app"
    },
    "/_app/projects/$projectId/videos/$videoId": {
      "filePath": "_app/projects/$projectId/videos/$videoId.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
